
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<ExpandableList>({})
export default class ExpandableList extends Vue {
	@Prop({ type: Array, required: true }) private items!: { [key: string]: any }[];
	@Prop({ type: String, required: false, default: 'id' }) private itemKey!: string;
	@Prop({ type: String, required: true }) private subItemsProperty!: string;
	@Prop({ type: String, required: false, default: 'id' }) private subItemKey!: string;
	@Prop({ type: String, required: false }) private subgroupProperty!: string;

	private expandedItems: any[] = [];

	private toggleExpandedItems(itemId: number): void {
		if (this.expandedItems.includes(itemId)) {
			this.expandedItems = this.expandedItems.filter((id: number) => id !== itemId);
		}
		else {
			this.expandedItems.push(itemId);
		}
	}
}
